import React, { useState, Fragment } from 'react';
import { map } from 'lodash';

const Lines = ({ onContinue }) => {

  const [selectedLine, selectLine] = useState(null);

  const onLineClick = (event, num) => {
    event.preventDefault();
    selectLine(num);
  };

  return (
    <Fragment>
      <div className="layout -fixed-bottom">
        <div className="header">
          <div className="header_title">Select number of lines</div>
        </div>
        <div className="content">
          <h2 className="line-question">How many lines do you need?</h2>
          <div className="line-note">You’ll need a line per device.</div>
          <div className="start_counts -billing">
            {
              map([1, 2, 3, 4, 5], (num, index) => {
                return (
                  <h2
                    key={ `line${index}` }
                    className={ `start_counts-item${selectedLine === num ? ' -selected' : ''}` }
                    onClick={ (event) => { onLineClick(event, num) } }
                  >
                    { num }
                  </h2>
                )
              })
            }
            </div>
        </div>
        <div className="footer -fixed">
          <button onClick={() => onContinue(selectedLine)} className="button -billing -lines" disabled={ selectedLine ? '' : 'disabled' }>
            Continue
          </button>
        </div>
      </div>
    </Fragment>
  )
};

export default Lines;
